export const AUDIENCES_WRAPPER_FIELDS = {
  AUDIENCES_LIST: "audiencesList",
  AUDIENCES_COUNT: "audiencesCount",
};

export const AUDIENCE_ITEM_FIELDS = {
  ID: "audienceId",
  PUB_ID: "pubId",
  TITLE: "title",
  AUDIENCE_ID: "audienceId",
  COUNT: "count",
  LABEL: "label",
  EDITABLE: "editable",
  ZONE_ID: "zoneId",
};

export const AUDIENCES_CREATE_FIELDS = {
  TITLE: "title",
  LABEL: "label",
  EDITABLE: "editable",
  ZONE_ID: "zone_id",
};

export const AUDIENCES_DELETE_FIELDS = {
  ID: "audienceId",
};

export const AUDIENCES_UPDATE_FIELDS = {
  ID: "audienceId",
  TITLE: "title",
  LABEL: "label",
  EDITABLE: "editable",
  ZONE_ID: "zone_id",
};
